import { Injectable, signal, TemplateRef } from '@angular/core';
import type { IStepOption } from './step-option';

/** Hands the step template registered by `<tour-step-template>` to the anchors that open it. */
@Injectable()
export class TourStepTemplateRegistry {
  readonly panel = signal<TemplateRef<{ step: IStepOption }> | null>(null);
}
